import axios from 'axios'
import { getServerApi } from '../../../config/deployment'

let envUri = getServerApi()
let locServiceV2 = envUri+'/api/location/v2/address'

export const getLocation=(locationRequest)=>{
    return axios.get(locServiceV2, {
        params: {
          county: locationRequest.address.county,
          municipality: locationRequest.address.municipality,
          district: locationRequest.address.district,
          street: locationRequest.address.street,
          number: locationRequest.address.number,
          apartNumber: locationRequest.address.apartNumber,
          apiKey: "abg34sdusf893LAD3d7adNFLnas"
        }
      })
      .then(res => {
        let myData = locationRequest
        let firstFromResponse = {}
        if(res.data.body.constructor === Array) firstFromResponse = res.data.body[0]
        else firstFromResponse = res.data.body
        
        for (let element in firstFromResponse) if (element != 'Address') myData[element] = firstFromResponse[element]
    
        if(firstFromResponse.Address) for (let dt in firstFromResponse.Address[0]) myData.address[dt] = firstFromResponse.Address[0][dt]

        return myData

    })
      .catch(err => {
        return locationRequest
      })
  }


// WEBPACK FOOTER //
// ./src/platform/location/services/locationService.js